import React, { Component } from 'react';
import { Field } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import queryString from 'query-string';
import { Breadcrumb, Grid, Row, Col, Panel, ButtonToolbar, Button, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Data } from 'react-data-grid-addons';
import _ from 'lodash';
import classNames from 'classnames';

import { InputField, DisabledInputField } from '../Common/inputField';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { RowRenderer } from '../Common/rowRenderer';
import { Selection, MultiSelection } from '../Common/selection';
import { DatePicker } from '../Common/datePicker';
import { DateFormatter, formatDate } from '../Common/dateFormat';
import ConfirmActionModal from '../Common/confirmActionModal';
import AccountDropdown from './accountDropdown';
import PaymentMethodOptions from '../Common/arapPaymentOptions';
import CashFormatter from '../Common/cashFormatter';
import { numberWithCommas } from '../Common/numberWithCommas';

class CreateAR extends Component {
  constructor() {
    super();
    this.state = {
      invoices: {
        rows: [],
        sortColumn: null,
        sortDirection: null
      },
      selectedInvoices: {
        rows: [],
        sortColumn: null,
        sortDirection: null
      },
      unpaidAmount: 0,
      totalAmount: 0,
      checkAuthorizeOpen: false,
      action: null,
      waiveShouldDisable: true,
      waiveAmount: 0,
      penaltyAmount: 0,
      warnPaymentDate: false,
    };
    this.moveInvoices = this.moveInvoices.bind(this);
    this.renderWaiveCheckbox = this.renderWaiveCheckbox.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.handleWaiveCheckboxChange = this.handleWaiveCheckboxChange.bind(this);
    this.renderInvoiceDateRadio = this.renderInvoiceDateRadio.bind(this);
    this.closeCheckAuthorize = this.closeCheckAuthorize.bind(this);
    this.checkAuthorize = this.checkAuthorize.bind(this);
    this.handleWaiveInputChange = this.handleWaiveInputChange.bind(this);
    this.renderWaiveInputField = this.renderWaiveInputField.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  componentWillMount() {
    this.props.clearARDetail();
    this.props.clearARForm();
    this.props.clearCredits();
    this.props.fetchCustomers();
    const queryObj = queryString.parse(this.props.location.search);
    const custId = queryObj.cust_id;
    if (custId) {
      this.props.changeField('Customer', parseFloat(custId), 'createAR');
    }
    this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAR');
    this.props.setDefaultOfForm('penaltyAmount', 0.00, 'createAR');
    this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAR');
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.penaltyAmount !== this.props.penaltyAmount) {
      const penaltyAmount = parseFloat(nextProps.penaltyAmount) || 0;
      this.setState({ penaltyAmount });
    }
    if (nextProps.customer_id && nextProps.customer_id !== this.props.customer_id) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(this.props.toDate);
      const invoiceDate = this.props.invoiceDate;
      this.props.fetchCustomerDetail(nextProps.customer_id.value || nextProps.customer_id);
      this.props.fetchARCredits(nextProps.customer_id.value || nextProps.customer_id);
      this.props.fetchARInvoices(
        nextProps.customer_id.value || nextProps.customer_id,
        invoiceDate,
        fromDate,
        toDate,
      );
    }
    if (nextProps.invoices && nextProps.invoices !== this.props.invoices) {
      const invoices = { ...this.state.invoices, rows: nextProps.invoices };
      const selectedInvoices = { ...this.state.selectedInvoices, rows: [] };
      this.setState({ invoices, selectedInvoices });
    }
    if (nextProps.invoiceDate && nextProps.invoiceDate !== this.props.invoiceDate) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(this.props.toDate);
      if (this.props.customer_id) {
        this.props.fetchARInvoices(
          this.props.customer_id.value || this.props.customer_id,
          nextProps.invoiceDate,
          fromDate,
          toDate
        );
      }
    }

    if (!nextProps.invoiceDate) {
      this.props.setDefaultOfForm('InvoiceDate', 'all', 'createAR');
    }

    if (nextProps.fromDate && nextProps.fromDate !== this.props.fromDate) {
      const fromDate = formatDate(nextProps.fromDate);
      const toDate = formatDate(this.props.toDate);
      if (this.props.customer_id) {
        this.props.fetchARInvoices(
          this.props.customer_id.value || this.props.customer_id,
          this.props.invoiceDate,
          fromDate,
          toDate
        );
      }
    }
    if (nextProps.toDate && nextProps.toDate !== this.props.toDate) {
      const fromDate = formatDate(this.props.fromDate);
      const toDate = formatDate(nextProps.toDate);
      if (this.props.customer_id) {
        this.props.fetchARInvoices(
          this.props.customer_id.value || this.props.customer_id,
          this.props.invoiceDate,
          fromDate,
          toDate
        );
      }
    }
    if (nextProps.checkPasswordSuccess && nextProps.checkPasswordSuccess !== this.props.checkPasswordSuccess) {
      this.closeCheckAuthorize();
      const formProps = {
        Customer: this.props.customer_id,
        TotalPayment: this.props.totalPayment,
        Method: this.props.method,
        CheckNum: this.props.checkNum,
        Account: this.props.account,
        Discount: this.props.discount,
        Waive: this.props.waive,
        Note: this.props.note,
        WaiveAmount: this.props.waiveAmount,
        PenaltyAmount: this.props.penaltyAmount,
      };
      // this.handleFormSubmit(formProps);
    }
  }

  componentWillUnmount() {
    this.props.clearARForm();
    this.props.clearCredits();
  }

  getBsStyle(input, value) {
    return input === value ? 'success' : 'primary';
  }

  checkAuthorize(password) {
    this.props.checkPassword(password);
  }

  openCheckAuthorize(action) {
    this.props.clearCheckPassword();
    this.setState({ checkAuthorizeOpen: true, action });
  }

  closeCheckAuthorize() {
    this.setState({ checkAuthorizeOpen: false });
  }

  calculateWaiveAmount() {
    const discount = parseFloat(this.props.discount) || 0;
    const totalAmount = parseFloat(this.state.totalAmount) || 0;
    let finalAmount = ((100 - discount) / 100) * totalAmount;
    finalAmount = finalAmount.toFixed(2) || 0;
    const totalPayment = parseFloat(this.props.totalPayment) || 0;
    let waiveAmount = finalAmount - totalPayment;
    waiveAmount = waiveAmount.toFixed(2);
    return waiveAmount;
  }

  refund(finalBalance) {
    const refundProps = {
      Account: this.props.account,
      Customer: this.props.customer_id,
      CheckNum: this.props.checkNum,
      Method: this.props.method,
      TotalPayment: finalBalance,
      PaymentDate: this.props.paymentDate,
    };
    const rows = Data.Selectors.getRows(this.state.selectedInvoices);
    this.props.refundAR(refundProps, rows)
      .then(() => {
        if (this.props.arRefunded && !this.props.arRefundError) {
          this.props.router.push('/AR');
        }
      });
  }

  moveInvoices(invoice, from) {
    const invoices = { ...this.state.invoices };
    const selectedInvoices = { ...this.state.selectedInvoices };
    let index;
    if (from === 'invoices') {
      index = _.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
      if (index > -1) {
        invoices.rows.splice(index, 1);
      }
      index = _.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
      if (index === -1) {
        selectedInvoices.rows.push(invoice);
      }
    } else if (from === 'selectedInvoices') {
      index = _.findIndex(selectedInvoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
      if (index > -1) {
        selectedInvoices.rows.splice(index, 1);
      }
      index = _.findIndex(invoices.rows, { SalesInvoice_id: invoice.SalesInvoice_id });
      if (index === -1) {
        invoices.rows.push(invoice);
      }
    }
    let totalAmount = 0;
    selectedInvoices.rows.map(r => {
      totalAmount += parseFloat(r.UnpaidAmount) || 0;
    });
    this.setState({ invoices, selectedInvoices, totalAmount });
  }

  getCustomerOptions(field) {
      const customerOptions = [];
      this.props.customers.map(customer => {
          customerOptions.push({ value: customer.Customer_id, label: customer[field] });
      });
      return customerOptions;
  }

  debouncedCreateAR = _.debounce((formProps, rows) => {
    this.props.createAR(formProps, rows).then(
      () => {
        if (this.props.arCreated && !this.props.arCreateError) {
          this.props.router.push('/AR');
        }
      }
    );
  }, 500, { maxWait: 1000 })

  handleFormSubmit() {
    if (!this.props.paymentDate) {
      this.setState({ warnPaymentDate: true });
      return;
    } else {
      this.setState({ warnPaymentDate: false });
    }
    const formProps = {
      Customer: this.props.customer_id,
      TotalPayment: parseFloat(this.props.totalPayment || 0).toFixed(2),
      PenaltyAmount: parseFloat(this.props.penaltyAmount || 0).toFixed(2),
      PaymentDate: this.props.paymentDate,
      Method: this.props.method,
      CheckNum: this.props.checkNum,
      Account: this.props.account.value,
      AccountName: this.props.account.label,
      // Discount: parseFloat(this.props.discount),
      // DiscountedAmount: ((parseFloat(this.state.totalAmount) * parseFloat(this.props.discount)) / 100).toFixed(2) || 0,
      Note: this.props.note,
      Waive: this.props.waive,
      WaiveAmount: parseFloat(this.state.waiveAmount || 0).toFixed(2),
      TotalAmount: parseFloat(this.state.totalAmount || 0).toFixed(2),
    };
    const rows = Data.Selectors.getRows(this.state.selectedInvoices);
    // rows.map(row => {
    //   const discountAmount = ((parseFloat(row.UnpaidAmount) * parseFloat(this.props.discount)) / 100).toFixed(2);
    //   row.DiscountedAmount = discountAmount || 0;
    // });

    this.debouncedCreateAR(formProps, rows);
  }

  renderDatePicker(fieldName, placeholder) {
    return (
      <Button bsStyle='primary'>
        <Field name={fieldName} disabled={this.props.invoiceDate !== 'range'} placeholder={placeholder} component={DatePicker} />
      </Button>
    );
  }

  getBillingAddress() {
    const { currentCustomerDetail } = this.props;
    let Address1 = '';
    let Address2 = '';
    if (currentCustomerDetail && currentCustomerDetail.Billing) {
        Address1 = currentCustomerDetail.Billing.Street;
        Address2 = `${currentCustomerDetail.Billing.City}, ${currentCustomerDetail.Billing.State} ${currentCustomerDetail.Billing.Zip}`;
    }
    return [Address1, Address2];
  }

  renderCustomers() {
    if (this.props.customersIsLoading && !this.props.customersError) {
      return <Spinner />;
    } else if (this.props.customersError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const customerNameOptions = this.getCustomerOptions('Name'); // Return a JSON in the format of React-Select's options
    const customerNumOptions = this.getCustomerOptions('CustomerNum');
    const customerPhoneOptions = this.getCustomerOptions('Telephone'); // Return a JSON in the format of React-Select's options
    const customerDescOptions = this.getCustomerOptions('Description');
    let billingAddress = ['', ''];
    const { customer_id, currentCustomerDetail } = this.props;
    let contact = null;
    let phone = null;
    if (customer_id && currentCustomerDetail && currentCustomerDetail.Billing) {
      contact = `${currentCustomerDetail.Billing.FirstName} ${currentCustomerDetail.Billing.LastName}`;
      phone = currentCustomerDetail.Billing.Telephone;
      billingAddress = this.getBillingAddress();
    }
    return (
      <div>
        <Row className='mb0'>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="customer_no" />
              <span style={{ color: 'red' }} >*</span>
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Customer' component={Selection} matchPos="any" options={customerNumOptions} />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="customer_name" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Customer' component={Selection} matchPos="any" options={customerNameOptions} />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="phone" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Customer' component={Selection} matchPos="any" options={customerPhoneOptions} />
            </Col>
            <label className='col-sm-4 inlineLabel' >
              <Translate value="note" />
            </label>
            <Col sm={8} className='mb-md'>
              <Field name='Customer' component={Selection} options={customerDescOptions} />
            </Col>
          </Col>
          <Col sm={4}>
            <label className='col-sm-3'>
              <Translate value="contact" />:
            </label>
            <Col sm={9}>
              {contact}
            </Col>
            <label className='col-sm-3'>
              <Translate value="phone" />:
            </label>
            <Col sm={9}>
              {phone}
            </Col>
            <label className='col-sm-3'>
              <Translate value="address" />:
            </label>
            {<Col sm={9}>
              {billingAddress[0]}
              <br />
              {billingAddress[1]}
            </Col>}
          </Col>
        </Row>
      </div>
    );
  }

  renderInvoices() {
    if (this.props.invoicesIsLoading && !this.props.invoicesError) {
      return <Spinner />;
    } else if (this.props.invoicesError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            {JSON.stringify(this.props.invoicesError)}
          </div>
        </ContentWrapper>
      );
    }

    // Parameters of the react-data-grid
    const getRows = () => {
      const rows = Data.Selectors.getRows(this.state.invoices);
      return rows;
    };

    const getSize = () => {
      const len = getRows().length;
      return len;
    };

    const rowGetter = rowIdx => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const invoices = Object.assign({}, this.state.invoices, { sortColumn, sortDirection });
      this.setState({ invoices });
    };

    // Column difinition
    const columns = [
      {
        key: 'InvoiceNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true
      },
      {
        key: 'PostingDate',
        name: <Translate value="invoice_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'BillDueDate',
        name: <Translate value="due_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'Amount',
        name: <Translate value="amount" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'UnpaidAmount',
        name: <Translate value="balance" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
    ];

    return (
      <div style={{ maxWidth: '100%' }} id="CreateAR-dataGrid1">
        <ReactDataGrid
          rowRenderer={
            <RowRenderer
              onDoubleClick={this.moveInvoices}
              from='invoices'
              to='selectedInvoices'
            />
          }
          onGridSort={handleGridSort}
          columns={columns}
          rowHeight={25}
          minHeight={390}
          rowGetter={rowGetter}
          rowsCount={getSize()}
        />
      </div>
    );
  }

  renderSelectedInvoices() {
    // if (this.props.customersIsLoading && !this.props.customersError) return <Spinner/>
    // else if (this.props.customersError) return <ContentWrapper><div className='alert alert-danger'>{JSON.stringify(this.props.customersError)}</div></ContentWrapper>
    // else {
    // Parameters of the react-data-grid
    const getRows = () => {
      return Data.Selectors.getRows(this.state.selectedInvoices);
    };

    const getSize = () => {
      return getRows().length;
    };

    const rowGetter = rowIdx => {
      const rows = getRows();
      return rows[rowIdx];
    };

    // Handle the sortable function
    const handleGridSort = (sortColumn, sortDirection) => {
      const selectedInvoices = Object.assign({}, this.state.selectedInvoices, { sortColumn, sortDirection });
      this.setState({ selectedInvoices });
    };

    // Column difinition
    const columns = [
      {
        key: 'InvoiceNum',
        name: <Translate value="invoice_no" />,
        resizable: true,
        sortable: true,
        filterable: true
      },
      {
        key: 'PostingDate',
        name: <Translate value="invoice_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'BillDueDate',
        name: <Translate value="due_date" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: DateFormatter
      },
      {
        key: 'Amount',
        name: <Translate value="amount" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
      {
        key: 'UnpaidAmount',
        name: <Translate value="balance" />,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: CashFormatter,
      },
    ];

    return (
      <div style={{ maxWidth: '100%' }} id="CreateAR-dataGrid2">
        <ReactDataGrid
          rowRenderer={
            <RowRenderer
              onDoubleClick={this.moveInvoices}
              from='selectedInvoices'
              to='invoices'
            />
          }
          onGridSort={handleGridSort}
          columns={columns}
          rowHeight={25}
          minHeight={390}
          rowGetter={rowGetter}
          rowsCount={getSize()}
        />
      </div>
    );
    // }
  }

  renderCheckNum() {
    return (
      <Field name='CheckNum' component={InputField} />
    );
  }

  getCreditOptions() {
    const creditOptions = [];
    if (this.props.credits) {
      this.props.credits.map(credit => {  //check the field name of credits when backend finish the API
        creditOptions.push({ value: credit.SalesReturn_id, label: `${credit.SRNum} | ${credit.FinalPrice}` });
      });
    }
    return creditOptions;
  }

  renderCredits() {
    if (this.props.creditsIsLoading && !this.props.creditsError) {
      return <Spinner />;
    } else if (this.props.creditsError) {
      return (
        <ContentWrapper>
          <div className='alert alert-danger'>
            {JSON.stringify(this.props.creditsError)}
          </div>
        </ContentWrapper>
      );
    }
    const creditOptions = this.getCreditOptions(); // Return a JSON in the format of React-Select's options
    return (
      <Field name='Credits' component={MultiSelection} options={creditOptions} />
    );
  }

  renderResponse() {
    const {
      arCreated, arCreateError, arIsCreating, arIsRefunding, arRefunded, arRefundError,
    } = this.props;
    if (arCreated || arRefunded) {
      return (
        <ContentWrapper>
          <div className='alert alert-success'>Success!</div>
        </ContentWrapper>
      );
    } else if ((arIsCreating && !arCreateError) || (arIsRefunding && !arRefundError)) {
      return (
        <ContentWrapper>
          <div className='alert alert-info'>
            ...<Translate value="reading_data" />
          </div>
        </ContentWrapper>
      );
    } // else if (arCreateError) {
    //   return (
    //     <ContentWrapper>
    //       <div className='alert alert-danger'>
    //         {arCreateError}
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    return <ContentWrapper />;
  }

  checkPermission(permission) {
    return false;
  }

  renderInvoiceDateRadio(props) {
    const fromDate = 'FromDate';
    const toDate = 'ToDate';
    return (
      <ButtonToolbar className='mb-md radio-filter-buttons'>
        <Button bsStyle={this.getBsStyle(props.input.value, 'all')}>
          <div className='radio'>
            <label htmlFor='all-radio-filter'>
              <input
                {...props.input}
                type='radio'
                id='all-radio-filter'
                className='statusFilterRadios'
                value='all'
                checked={props.input.value === 'all'}
              />
              <Translate value="all" />
            </label>
          </div>
        </Button>
        <Button /* id="date-range-radio-button" */ bsStyle={this.getBsStyle(props.input.value, 'range')}>
          <div className="radio">
            <label htmlFor="dateRange-radio-filter">
              <input
                {...props.input}
                type='radio'
                id='dateRange-radio-filter'
                className='statusFilterRadios'
                value='range'
                checked={props.input.value === 'range'}
              />
              <Translate value="date_range" />
            </label>
          </div>
        </Button>
        {this.renderDatePicker(fromDate, 'Start')}
        {this.renderDatePicker(toDate, 'End')}
      </ButtonToolbar>
    );
  }

  handleWaiveCheckboxChange(event) {
    const target = event.target;

    if (!target.checked) {
      this.props.setDefaultOfForm('waiveAmount', 0.00, 'createAR');
      this.setState({
        waiveAmount: 0.00,
      });
    } else {
      this.props.setDefaultOfForm('waiveAmount', this.calculateWaiveAmount(), 'createAR');
      this.setState({
        waiveAmount: this.calculateWaiveAmount(),
      });
    }
    this.setState({
      waiveShouldDisable: !target.checked,
    });
  }

  renderWaiveCheckbox(props) {
    return (
      <div className='form-group'>
        <Col xs={6}>
          <label>
            <input
              {...props.input}
              type='checkbox'
              value='waive'
              checked={props.input.value}
              onChange={this.handleWaiveCheckboxChange}
            />
          </label>
        </Col>
      </div>
    );
  }

  handleWaiveInputChange(event) {
    this.setState({
      waiveAmount: event.target.value,
    });
  }

  renderWaiveInputField(props) {
    const { meta: { touched, error }, className } = props;
    const inputClass = classNames({ 'parsley-error': touched && error }, 'form-control', className);
    return (
      <div>
        <Input
          {...props.input}
          className={inputClass}
          type='text'
          onChange={(event) => {
            props.input.onChange(event);
            this.handleWaiveInputChange(event);
          }}
          disabled={props.disabled}
        />
        {touched && error && <span className="parsley-error-message">{error}</span>}
      </div>
    );
  }

  renderPaymentDateError() {
    if (this.state.warnPaymentDate) {
      return (
        <label className="alert alert-danger"><Translate value="payment_date_required" /></label>
      );
    }
  }

  render() {
    const createDialogStyle = {
      width: '550px',
      height: '300px',
      marginLeft: '-15%',
    };

    const { handleSubmit, pristine, method, submitting } = this.props;
    const { waiveShouldDisable, waiveAmount, penaltyAmount } = this.state;

    const paymentMethodIsCredit = (method === 'Credit' || (method && method.value === 'Credit'));

    const twoDecimalZero = (0).toFixed(2);
    const discount = parseFloat(this.props.discount) || twoDecimalZero;
    const totalAmount = parseFloat(this.state.totalAmount) || twoDecimalZero;
    const balance = (((100 - discount) / 100) * totalAmount).toFixed(2) || twoDecimalZero;
    const totalPayment = parseFloat(this.props.totalPayment) || twoDecimalZero;
    const finalBalance = (penaltyAmount + (balance - waiveAmount - totalPayment)).toFixed(2) || twoDecimalZero;
    // finalBalance = finalBalance > 0 ? finalBalance : twoDecimalZero;

    return (
      <ContentWrapper>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Translate value="ar_slashsign_ap" />
            </Breadcrumb.Item>
            <Breadcrumb.Item active='true'>
              <Translate value="account_receivable" />
            </Breadcrumb.Item>
          </Breadcrumb> {/* End Navigation Trail */}
          <Grid id='AR-create'>
            <ButtonToolbar>
              <Button
                bsStyle='success'
                type='submit'
                disabled={pristine || submitting}
              >
                <em className="fa fa-save" /><Translate value="save" />
              </Button>
              <Button
                bsStyle='danger'
                type='button'
                onClick={() => (
                  document.referrer === window.location.href
                    ? this.props.router.push('/AR')
                    : this.props.router.goBack()
                )}
              >
                <em className="fa fa-close" /><Translate value="cancel" />
              </Button>
            </ButtonToolbar>
            <Panel id='customers'>
              { this.renderCustomers() }
            </Panel>
            <Panel>
              <Row id='date-range-picker' className='form-horizontal'>
                <div className='col-sm-7'>
                  <label className='floatLeft'>
                    <Translate value="invoice_date" />
                  </label>
                  <Field name='InvoiceDate' component={this.renderInvoiceDateRadio} />
                </div>
              </Row>
              <Row>
                <Col sm={6}>
                  { this.renderInvoices() }
                </Col>
                <Col sm={6}>
                  { this.renderSelectedInvoices() }
                </Col>
              </Row>
            </Panel>
            <Panel id='check-out-information'>
              <Row>
                <Col sm={1}>
                  <label className='text-nowrap inlineLabel' >
                    <Translate value="payment_method" />
                    <span className='asteriksReq'>*</span>
                  </label>
                </Col>
                <Col sm={2}>
                  <Field name='Method' className='select-menu-drop-up' component={Selection} options={PaymentMethodOptions} />
                </Col>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="check_number" />
                  </label>
                </Col>
                <Col sm={2}>
                  { paymentMethodIsCredit && this.renderCredits() }
                  { !paymentMethodIsCredit && this.renderCheckNum() }
                </Col>
                {/*
                  <Col sm={2}>
                    <Row>
                      <Col sm={6}>
                        <label className='inlineLabel' >
                          <Translate value="discount" /> (%)
                        </label>
                      </Col>
                      <Col sm={6}>
                        <Field name='Discount' component={InputField} />
                      </Col>
                    </Row>
                  </Col>
                */}
                {/* Waive section */}
                <Col sm={2}>
                  <Row>
                    <Col sm={3}>
                      <label className='inlineLabel' >
                        <Translate value="waive" />
                      </label>
                    </Col>
                    {/*
                      <Col sm={2}>
                        <Field name='Waive' component={this.renderWaiveCheckbox} />
                      </Col>
                    */}
                    <Col sm={6} smOffset={1}>
                      <Field name='waiveAmount' component={this.renderWaiveInputField} />
                    </Col>
                  </Row>
                </Col>
                <Col xs={2}>
                  <Row>
                    <Col xs={4}>
                      <label>
                        <Translate value="payment_date" />
                        <span className="asteriksReq text-nowrap">*</span>
                      </label>
                    </Col>
                    <Col xs={7}>
                      <Field name='PaymentDate' component={DatePicker} dropUp maxDate={new Date()} />
                    </Col>
                  </Row>
                </Col>
                {/* End waive section */}
                <Col sm={1}>
                  <label>
                    <Translate value="balance" /> :
                  </label>
                </Col>
                <Col sm={1}>
                  <label>
                    {'$'+numberWithCommas(balance)}
                  </label>
                </Col>
              </Row>
              <Row>
                <label className='col-sm-1 inlineLabel' >
                  <Translate value="account" />
                  <span style={{ color: 'red' }} >*</span>
                </label>
                <Col sm={2}>
                  {/*<Field name='Account' component={InputField} />*/}
                  <AccountDropdown  className='select-menu-drop-up' />
                </Col>
                <label className='col-sm-1 text-nowrap inlineLabel' >
                  <Translate value="receive_amount" />
                  <span className='asteriksReq'>*</span>
                </label>
                <Col sm={2}>
                  {(totalPayment === twoDecimalZero && finalBalance < 0) ?
                    <Field name="TotalPaymentDisabled" component={DisabledInputField} /> :
                    <Field name="TotalPayment" component={InputField} />
                  }
                </Col>
                <Col xs={4}>
                  <Row>
                    <Col xs={2}>
                      <label><Translate value="penalty" /></label>
                    </Col>
                    <Col xs={3}>
                      <Field name='PenaltyAmount' component={InputField} />
                    </Col>
                    {/* <Col xs={6} xsOffset={1}>
                      {this.renderPaymentDateError()}
                    </Col> */}
                  </Row>
                </Col>
                <label className='col-sm-1'>
                  <Translate value="final_balance" /> :
                </label>
                <label className='col-sm-1'>
                  {'$'+numberWithCommas(finalBalance)}
                </label>
              </Row>
              <div className='horizontal-divider' />
              <Row /* id='hint' */>
                <Col sm={1}>
                  <label className='inlineLabel' >
                    <Translate value="note" />
                  </label>
                </Col>
                <Col sm={5}>
                  <Field name='Note' component={InputField} />
                </Col>
                <Col sm={4} />
                <Col sm={1}>
                  <Button
                    disabled={(finalBalance >= 0 || totalPayment !== twoDecimalZero)}
                    bsStyle="primary"
                    onClick={handleSubmit(() => { this.refund(finalBalance); })}
                  >
                    <Translate value="refund" />
                  </Button>
                </Col>
                {/*
                  <Col sm={3}>
                    <label className='authorize-label'>
                      <Translate value="authorization_required" />
                    </label>
                  </Col>
                */}
              </Row>
            </Panel>
            <Row>
              {this.renderResponse()}
            </Row>
          </Grid>
        </form>
        <SkyLightStateless
          dialogStyles={createDialogStyle}
          isVisible={this.state.checkAuthorizeOpen}
          onCloseClicked={this.closeCheckAuthorize}
        >
          <ConfirmActionModal
            case='confirmPassword'
            closeC={this.checkAuthorize}
            checkPasswordFailure={this.props.checkPasswordFailure}
          />
        </SkyLightStateless>
      </ContentWrapper>
    );
  }
}

export default CreateAR;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/createAR.jsx